import _ from 'lodash';
import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';
import {COLORS} from '@/utils/constants';
import {getSubmissions} from '@/containers/E4ImpactProjects/TabSections/Output/filterByEmployees';

/**
 * Survey: PROJECT - BASELINE IMPACT
 * Question: How many employees are on ... ?
 *
 * == baseline
 * question68_item_1_number - Permanent contracts
 * question68_item_2_number - Fix-term contracts
 * question68_total_number - Total employees
 *
 * Survey: PROJECT- FINAL IMPACT
 * Question: How many employees are on ... ?
 *
 * == final
 * question12_item_1_number - Permanent contracts
 * question12_item_2_number - Fix-term contracts
 * question12_total_number - Total employees
 *
 * @param props
 * @returns
 */
export const newJobsByTermOfContractsChartCalculation = (props: any) => {
    const positiveSubmissions = getSubmissions(props);

    const filteredFinal = Object.values(positiveSubmissions).map(({finalSubmission}) => finalSubmission);
    const filteredBaseline = Object.values(positiveSubmissions).map(({baselineSubmission}) => baselineSubmission);

    const permanentContracts = _.sumBy(filteredFinal, 'question12_item_1_number') - _.sumBy(filteredBaseline, 'question68_item_1_number');
    const fixTermContracts = _.sumBy(filteredFinal, 'question12_item_2_number') - _.sumBy(filteredBaseline, 'question68_item_2_number')

    const data = [
        {
            name: 'Permanent contracts',
            color: COLORS.e4ImpactBlue,
            y: permanentContracts < 0 ? 0 : permanentContracts
        },
        {
            name: 'Fix-term contracts',
            color: COLORS.e4ImpactOrange,
            y: fixTermContracts < 0 ? 0 : fixTermContracts
        },
    ];

    return getDefaultPieFormatting(
        'KPI: New jobs by term of contracts',
        data
    ) as Highcharts.Options;
}